import { Directive, ElementRef, Input, OnChanges, Renderer2, inject } from '@angular/core';

@Directive({
    selector: '[msRemoveHref]',
})
export class RemoveHrefDirective implements OnChanges {
    private element = inject(ElementRef);
    private renderer = inject(Renderer2);

    @Input('msRemoveHref') removeHref = false;

    ngOnChanges(): void {
        if (this.removeHref) {
            this.renderer.removeAttribute(this.element.nativeElement, 'href');
        }
    }
}
